import React, { Component } from "react";
import { bool } from "prop-types";
import { getDevicePlatform, getDisplay } from "util/device";
import ShortcutAction from "./ShortcutAction";

class ShortcutLink extends Component {
    static propTypes = {
        isMobile: bool.isRequired,
    };

    render() {
        const { isMobile } = this.props;

        const actionsMobile = [
            {
                icon: "financiaciones-white",
                label: " Pagos",
                link: "/lotPayments",
                color: "active-color",
            },
            {
                icon: "cheques",
                label: " Echeq",
                link: "/echecks",
                color: "hover-color",
            },
            {
                icon: "transferencias-white",
                label: " Transferir",
                link: "/transfers",
                color: "primary-color",
            },
        ];

        const actionsDesktop = [
            {
                icon: "transferencias",
                label: " Transferir",
                link: "/transfers",
                color: "active-color",
            },
            {
                icon: "cheques",
                label: " Echeq",
                link: "/echecks",
                color: "primary-color",
            },
            {
                icon: "financiaciones",
                label: " Pagos",
                link: "/lotPayments",
                color: "primary-light",
            },
        ];

        return (
            <div className="shortcut-button">
                {isMobile || getDisplay === "mobile" || getDevicePlatform === "iOS"
                    ? actionsMobile.map(({ icon, label, link, color }) => (
                          <ShortcutAction icon={icon} label={label} href={link} color={color} isMobile={isMobile} />
                      ))
                    : actionsDesktop.map(({ icon, label, link, color }) => (
                          <ShortcutAction icon={icon} label={label} href={link} color={color} isMobile={isMobile} />
                      ))}
            </div>
        );
    }
}

export default ShortcutLink;
